import { atom } from 'recoil';

const LoadingState = atom<boolean>({
  key: 'loadingState',
  default: false
});

// esLint用
const Sample = ''

export { LoadingState,Sample };
